import React from 'react';
import LeftRightGroupableSelect from "../../../left-right-groupable-select/LeftRightGroupableSelect";

export default (props) => {
    const {
        key,
        value,
        forcedValue,
        data,
        rules,
        options,
        disabled,
        ruleRequired,
        isRequired,
        onChange
    } = props;

    return <LeftRightGroupableSelect
        options={data.options}
        groups={data.groups}
        defaultValue={value}
        value={forcedValue}
        onChange={onChange}
        title={options.title}
        renderSelectedSummary={options.renderSelectedSummary}
        renderDeselectAllText={options.renderDeselectAllText}
        renderGroupTitle={options.renderGroupTitle}
        renderOptionContent={options.renderOptionContent}
        getGroupId={options.getGroupId}
        getOptionId={options.getOptionId}
        getOptionDisabled={options.getOptionDisabled}
        getOptionGroupId={options.getOptionGroupId}
        disabled={disabled}
    />;
}
